import { queryOptions, useQuery } from "@tanstack/react-query";

import { Page, api } from "@/lib/api";
import { unwrapAxiosData } from "@/lib/api/query-utils";

export const keys = {
  page: (id: string) => ["page", id],
} as const;

export const pageQuery = (id: string) =>
  queryOptions({
    queryKey: keys.page(id),
    queryFn: (): Promise<Page> => unwrapAxiosData(api.pages.getPage(id)),
  });

export function usePageQuery(id: string) {
  return useQuery(pageQuery(id));
}
